import React, { useEffect, useRef, useState } from "react";
import { debounce } from "@mui/material";
import "./index.css";
import ICONS from "../../../assets/Icons";
import SVGComponent from "../SVGComponent";

const RectangleSearchBar = (props) => {
  const {
    showSearchBar,
    handleSearch,
    setSearchUserText,
    setCurrentPage,
    searchUserText,
    searchRef,
    placeholder,
    setIsAssignTagsClicked,
    setAssignTagsAccounts,
  } = props;

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);

  const inputref = useRef(null);
  const [placeholderText, setPlaceholderText] = useState(`${placeholder}   `);

  useEffect(() => {
    const interval = setInterval(() => {
      setPlaceholderText((prev) => prev.slice(1) + prev.charAt(0));
    }, 200);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (searchUserText.length > 0) {
      inputref.current.value = searchUserText;
    }
  }, []);

  const handlePaste = (event) => {
    const pastedText = event.clipboardData.getData("text");
    setCurrentPage(1);
    handleSearch(pastedText);
  };

  const handlechange = debounce((e) => {
    setCurrentPage(1);
    handleSearch(e.target.value);
    // setIsAssignTagsClicked(false);
    // if (setAssignTagsAccounts) {
    //   setAssignTagsAccounts([]);
    // }
  }, 500);

  const handleClear = () => {
    setCurrentPage(1);
    setSearchUserText("");
    inputref.current.value = "";
  };

  return (
    <div
      ref={searchRef}
      // style={{ border: props?.multiSelect && "none" }}
      className={`searchComponent-bar ${
        showSearchBar ? "search-component-expand" : "searchComponent_collapse"
      }`}
    >
      <label
        htmlFor="search"
        className="sr-only"
      >
        Search
      </label>

      <div className="searchComponent_bar_acc">
        <div
          className="searchComponent_inner_image_acc"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <SVGComponent
            url={ICONS?.SEARCH_WHITE}
            height={"var(--icon-sm)"}
            width={"var(--icon-sm)"}
            color={"var(--text-primary)"}
          />
        </div>

        <input
          ref={inputref}
          autoFocus
          onKeyUp={handlechange}
          onPaste={handlePaste}
          autoComplete="off"
          id="searchComponent"
          name="search"
          className={`block h-8 rounded-[10px] bg-[#244277] text-[#F9F9F9] placeholder:text-[#DADADA] placeholder:text-font-xs placeholder:ml-[30px] outline-none`}
          placeholder={isMobile ? placeholderText : placeholder}
          type="text"
        />
        {searchUserText && (
          <img
            onClick={handleClear}
            className="searchComponent_close_image_acc cursor-pointer"
            src={ICONS?.CLOSE_WITH_WHITE_CIRCLE}
            alt="search-close"
          />
        )}
      </div>
    </div>
  );
};

export default RectangleSearchBar;
